module.exports = __webpack_public_path__ + "img/time-management-1-dark.d146bcc7.svg";